const setIsFilterActive = (state, payload) => {
    state.isFilterActive = payload
}

export default {
    setIsFilterActive
}
